import { MetaData } from '@scentregroup/shared/types/meta-data'

interface IMetadataProps {
  country: string
  type:
    | 'homepage'
    | 'experience'
    | 'storefront'
    | 'gift-cards'
    | 'search'
    | 'privacy-policy'
    | 'terms-and-conditions'
    | 'promotions-terms-and-conditions'
    | 'default'
    | 'personalised-ads'
    | 'shop'
  category?: string
  retailer?: string
}

type MetaDataWithTitleDescription = Pick<MetaData, 'title' | 'description'>

export const getDefaultNationalMetaData = ({
  country,
  type,
  category,
  retailer,
}: IMetadataProps): Required<MetaDataWithTitleDescription> => {
  switch (type) {
    case 'homepage':
      return {
        title: `Westfield ${country} - Visit Our Centres or Browse Online`,
        description:
          'Westfield is your one-stop destination for shopping, leisure and entertainment. Discover 1000s of popular retailers in fashion, home, decor and more.',
      }
    case 'experience':
      return {
        title: `Westfield ${country} | ${category}`,
        description: `Westfield is home to your favourite ${category} products. Explore our range of ${category} products, categories, brands, events & offers.`,
      }
    case 'storefront':
      return {
        title: `Westfield ${country} | ${retailer}`,
        description: `${retailer} at Westfield - Shop online and explore ${retailer}’s range of products and categories. Find 100s of quality retailers at your local Westfield
`,
      }
    case 'gift-cards':
      return {
        title: `Westfield Gift Cards - Check Card Balance, Buy Gift Cards`,
        description: `Westfield Gift Cards opens doors to 8000+ shopping experiences in Westfield Centres across Australia. You can check card balances and buy Westfield gift cards online.`,
      }
    case 'privacy-policy':
      return {
        title: `National Website Privacy Policy | Westfield ${country}`,
        description: `Your privacy is important to us and we are committed to the protection of personal information. Read more on Westfield Australia's website privacy policy here.`,
      }
    case 'terms-and-conditions':
      return {
        title: `National Website Terms & Conditions | Westfield ${country}`,
        description: `We update our site as often as is practicable, but information can change often and we can't guarantee its accuracy at any time. Read more on Westfield Australia's website terms and conditions here.`,
      }
    case 'promotions-terms-and-conditions':
      return {
        title: `Promotions Terms & Conditions | Westfield ${country}`,
        description: `We update our site as often as is practicable, but information can change often and we can't guarantee its accuracy at any time. Read more on Westfield Australia's website terms and conditions here.`,
      }
    case 'search':
      return {
        title: `Westfield ${country} - Search Results`,
        description:
          'Westfield is your one-stop destination for shopping, leisure and entertainment. Discover 1000s of popular retailers in fashion, home, decor and more.',
      }
    case 'personalised-ads':
      return {
        title: `Personalised Ads`,
        description:
          'To show you the most relevant information and advertising, we collect details of your browsing session. If you would prefer to see general and potentially less relevant advertising, you can use the controls below.',
      }
    case 'shop':
      return {
        title: `Westfield online | Shop Westfield retailers online`,
        description:
          'Explore Westfield online, your ultimate shopping destination! Dive into a diverse range of products from Westfield retailers, all from the comfort of your home. Enjoy seamless online shopping experiences, offers and effortless delivery services. Start shopping today.',
      }
    case 'default':
    default:
      return {
        title: `Westfield ${country} - Visit Our Centres or Browse Online`,
        description:
          'Westfield is your one-stop destination for shopping, leisure and entertainment. Discover 1000s of popular retailers in fashion, home, decor and more.',
      }
  }
}
